import {recordRumDurationVital} from '../datadogRum';

type FunctionPerformanceContext = NonNullable<
  Parameters<typeof recordRumDurationVital>[1]['context']
>;

type FunctionPerformanceName =
  | 'addAbsoluteRuntime'
  | 'aggregateLines'
  | 'getAlignedData'
  | 'getFoundPanelSpecsApiAdded'
  | 'haveDataForPanelRegexFallback'
  | 'getMediaKeysImpl'
  | 'getPanelBankDiff'
  | 'keyInfoToDefaultPanelSpecs'
  | 'keysOfType'
  | 'immerAddColumnsToTable'
  | 'immerAugmentMediaHistory'
  | 'immerFetchProjectJobs'
  | 'immerFetchTriggerJobs'
  | 'immerLoadAgentThread'
  | 'immerLoadBoxData'
  | 'immerLoadHistoryFileTables'
  | 'immerPaginateArtifactVersions'
  | 'immerPaginateRunArtifacts'
  | 'immerPanelRootReducer'
  | 'immerPanelTreeSetPath'
  | 'immerRecentlyUsedJobs'
  | 'immerRefinePlotTables'
  | 'immerUpdateDefaultWorkspaceSpec'
  | 'makeUniqueKeyTypes'
  | 'unionLines';

/**
 * Starts a synchronous function measurement and returns an idempotent callback
 * that reports the elapsed time as a Datadog RUM duration vital.
 *
 * Pass only context that is already available in constant time. Deriving
 * context must not add scans or large allocations to the measured function.
 */
export function startFunctionPerformanceMeasure(
  name: FunctionPerformanceName
): (context?: FunctionPerformanceContext) => void {
  const startMark = performance.now();
  let finished = false;

  return context => {
    if (finished) {
      return;
    }
    finished = true;

    const duration = performance.now() - startMark;
    recordRumDurationVital(`workspace.func_perf.${name}`, {
      startTime: performance.timeOrigin + startMark,
      duration,
      description: `synchronous ${name} function duration`,
      context,
    });
  };
}
